import type { ToggleRelease } from 'app/types/feature-toggle-release'

// Releases declared in code ship with the deploy, so a release and its toggles
// are on every environment's Feature Toggles page without a manual step.
// A toggle joins one through the `release` key of its FEATURE_TOGGLE_METADATA entry.
export const FEATURE_TOGGLE_RELEASES = {
  'next-app': {
    name: `Next.app Release`,
    description: `Toggles that go on together for the next.app release.`,
    epics: [],
    started: `2026-10-20`,
  },
  'related-contacts': {
    name: `Related Contacts`,
    description: `Families and the primary contact: who staff talk to and who gets messaged for each person.`,
    epics: [`TRK-4005`],
    started: `2026-11-03`,
  },
} as const satisfies Record<string, ToggleRelease>

export type ReleaseSlug = keyof typeof FEATURE_TOGGLE_RELEASES
